module.exports = __webpack_public_path__ + "static/media/lncc.23c39dda.svg";